export const googleIds = {
  ZPAR: '1012625229306-cu4nl7vp10cl4gg335mkkqjdvr3g2hag.apps.googleusercontent.com',
  IWBR: '621660066022-euph88b13grrmr5imc8k156l1irns90v.apps.googleusercontent.com',
  WIBR: '38590970233-ssm6v9tmhms2npjb8h9a3ujm2r6eu65k.apps.googleusercontent.com',
  ICBR: '621660066022-euph88b13grrmr5imc8k156l1irns90v.apps.googleusercontent.com',
  CMBR: '1055661526765-1ql1flemjmfjcni6q2q47685om5boga1.apps.googleusercontent.com',
  '24MX': '1013517722907-rrtaai7b7n9rh2oupl04g139j78idb81.apps.googleusercontent.com',
  VAMX: '1041373493199-2qqr4obp75orps57g032rmojm9pa6pii.apps.googleusercontent.com',
  UBPE: '704572179391-37hnjmvh32efrk6ras1olk5brse8osi0.apps.googleusercontent.com',
  DVPE: '939327980329-ln80kkk1upj1t9g2i8cknjqqmci0dcs2.apps.googleusercontent.com',
  PLEC: '8376391920-ochc60lsi0mmh5rfkfj4a572dtbu6f44.apps.googleusercontent.com',
  CAPA: '563500332967-lhe6trr4guf72cil45pu97o6r54iiui7.apps.googleusercontent.com',
  LLVE: ''
};

export const facebookIds = {
  ZPAR: '533161370500846',
  IWBR: '251548061658132',
  WIBR: '306946583267463',
  ICBR: '251548061658132',
  CMBR: '578893310362375',
  '24MX': '1439390149611511',
  VAMX: '950098413017034',
  UBPE: '809369313365701',
  DVPE: '674462129242991',
  PLEC: '655792077817633',
  CAPA: '524861324267937',
  LLVE: ''
};

export const appleIds = {
  ZPAR: {
    appleId: 'ar.com.zonaprop',
    appleRedirectURI: window.location.href
  },
  IWBR: {
    appleId: 'br.com.imovelweb',
    appleRedirectURI: window.location.href
  },
  WIBR: {
    appleId: 'br.com.wimoveis',
    appleRedirectURI: window.location.href
  },
  ICBR: {
    appleId: 'br.com.imovelweb',
    appleRedirectURI: window.location.href
  },
  CMBR: {
    appleId: 'br.com.casamineira',
    appleRedirectURI: window.location.href
  },
  '24MX': {
    appleId: 'com.inmuebles24',
    appleRedirectURI: window.location.href
  },
  VAMX: {
    appleId: 'com.navent.realestate.vivanuncios',
    appleRedirectURI: window.location.href
  },
  UBPE: {
    appleId: 'pe.urbania',
    appleRedirectURI: window.location.href
  },
  DVPE: {
    appleId: 'com.adondevivir',
    appleRedirectURI: window.location.href
  },
  PLEC: {
    appleId: 'com.plusvalia',
    appleRedirectURI: window.location.href
  },
  CAPA: {
    appleId: 'com.compreoalquile',
    appleRedirectURI: window.location.href
  },
  LLVE: {
    appleId: '',
    appleRedirectURI: window.location.href
  }
};
